/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectStatusPatchV1Dto = {
  /**
   * Interval for maintenance in combination with intervalUnit (e.g., 6 months)
   */
  interval?: number;
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  intervalUnit?: ServiceObjectStatusPatchV1Dto.intervalUnit;
  /**
   * The next maintenance date. Must be after lastPerformedDate if it is provided.
   */
  nextDueDate?: string;
  /**
   * Notice period for the maintenance
   */
  notice?: number;
  /**
   * Name of this status
   */
  name?: string;
  /**
   * The current version of the entity
   */
  version: number;
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  type?: ServiceObjectStatusPatchV1Dto.type;
};
export namespace ServiceObjectStatusPatchV1Dto {
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  export enum intervalUnit {
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    YEAR = 'Year',
  }
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  export enum type {
    MAINTENANCE = 'Maintenance',
    INSPECTION = 'Inspection',
  }
}
